import React from 'react';
import '../Sass/Footer.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="name">Created by <span className="animated-text">Sejal Jaiswal💖💖</span></p>
    </footer>
  );
};

export default Footer;


